export default function Plus() {
    return (
        <svg className="plus" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17ZM9.20813 4.24947V7.79109H12.7499V9.20783H9.20813V12.7499H7.79139V9.20783H4.24947V7.79109H7.79139V4.24947H9.20813Z"
                fill="url(#paint0_linear_845_6264)"
            />
            <defs>
                <linearGradient id="paint0_linear_845_6264" x1="8.5" y1="0" x2="8.5" y2="17" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#3F68E0" />
                    <stop offset="1" stopColor="#7699FF" />
                </linearGradient>
            </defs>
        </svg>
    );
}
